<template>
  <div
    :style="parentStyle"
    class="background-text txt-color-dark border border-color-medium broadband-label-iframe-parent"
  >
    <iframe
      :id="ref"
      :src="url"
      :style="style"
      type="application/pdf"
      frameborder="0"
    />
  </div>
</template>

<script>

import utility from '../modules/utility';
// import { ifIsDevConsoleLog } from '../functions/helper';

export default {
  name: 'BroadbandLabel',
  props: {
    height: {
      type: String,
      required: false,
      default: '300px;',
    },
    lnk: {
      type: String,
      required: false,
      default: '',
    },
    width: {
      type: String,
      required: false,
      default: '150',
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ref: '',
      style: '',
      parentStyle: '',
      checkedHeight: 0,
      checkedSrc: '',
      collection: {
      },
    };
  },
  beforeMount() {
    this.ref = utility.makeid(9);
  },
  mounted() {
    const vm = this;
    window.addEventListener('message', (e) => {
      if (e.data.iframeHeight) {
        // ifIsDevConsoleLog([e.data.iframeId, vm.ref, e.data.iframeHeight, 'matched']);
        this.getLongest(e.data.iframeHeight, e.data.iframeId);
        // vm.checkedHeight = e.data.iframeHeight;
      }
      if (e.data.iframeSrc) {
        vm.checkedSrc = e.data.iframeSrc;
      }
      if (e.data.iframeId === vm.ref) {
        // ifIsDevConsoleLog([e.data.iframeId, vm.ref, e.data.iframeHeight, 'matched']);
        vm.listener();
      }
    });
  },
  methods: {
    getLongest(height, id) { // check last 4 heights receipt and change it
      this.collection[id] = height;
      const lengths = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.collection) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.collection.hasOwnProperty(key)) {
          lengths.push(this.collection[key]);
        }
      }
      this.checkedHeight = Math.max(...lengths);
    },
    listener() {
      const iframe = document.getElementById(this.ref);
      const innerDoc = iframe.contentDocument || iframe.contentWindow?.document;
      const body = innerDoc.querySelectorAll('body');
      const article = innerDoc.querySelectorAll('article');
      if (body) {
        body[0].style.cssText = 'margin: 0; overflow-y: hidden; overflow-x: hidden; width: 100%; ';
      }
      if (article) {
        article[0].style.cssText = 'margin: 0 auto; padding: 10px; calc(100% - 20px);'; // height: ${this.checkedHeight}px
      }
      // ifIsDevConsoleLog(innerDoc, 'innerdoc');
      this.parentStyle = `height: ${this.checkedHeight}px; width: 100%; background-color: #fbf7f7;`;
      this.style = `height: calc(${this.checkedHeight}px + 10px); width: 100%;`;
      // ifIsDevConsoleLog(this.style, 'this.style');
      iframe.style.height = `${this.checkedHeight}px`;
    },
  },
};
</script>
<style scoped>
.reset_css *{
  display: unset;
  background: unset;
  left: unset;
  right: unset;
  top: unset;
  bottom: unset;
  width: unset;
  height: unset;
  padding: unset;
  margin: unset;
  border: unset;
  color: unset;
  font: unset;
  font-size: unset;
}

</style>
